import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import StormReportsIndex from './storm_reports/Index.vue';
import VersionIndex from './version/Index.vue';
import AppSettingsIndex from './app_settings/Index.vue';
import LeadSourceReportIndex from './lead_source_report/Index.vue';
import DailyLeadsIndex from './daily_leads/Index.vue';
import WmtLeadsIndex from './wmt_leads/Index.vue';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';
import OnboardingInboxSetup from './onboarding/InboxSetup.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        {
          path: frontendURL('accounts/:accountId/storm_reports'),
          name: 'storm_reports_index',
          component: StormReportsIndex,
          meta: { permissions: ['administrator'] },
        },
        {
          path: frontendURL('accounts/:accountId/version'),
          name: 'version_index',
          component: VersionIndex,
          meta: { permissions: ['administrator'] },
        },
        {
          // 定制(2026-09-15): App设置(App登录IP白名单)
          path: frontendURL('accounts/:accountId/app_settings'),
          name: 'app_settings_index',
          component: AppSettingsIndex,
          meta: { permissions: ['administrator'] },
        },
        {
          // 定制: 留电来源报表(归属者×来源URL 留电数统计)
          path: frontendURL('accounts/:accountId/lead_source_report'),
          name: 'lead_source_report_index',
          component: LeadSourceReportIndex,
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          // 定制: 每日留电面板(今日/昨日 留电与对话, 所有人可见, 自树莓派监控屏移植)
          path: frontendURL('accounts/:accountId/daily_leads'),
          name: 'daily_leads_index',
          component: DailyLeadsIndex,
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          // 定制(2026-09-18): 王吉涛自媒体线索。meta 只能表达 role 粒度,
          // 真实门槛 = sidebar 条件隐藏(管理员+network_supervisor) + 后端 403
          path: frontendURL('accounts/:accountId/wmt_leads'),
          name: 'wmt_leads_index',
          component: WmtLeadsIndex,
          meta: { permissions: ['administrator', 'agent'] },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/onboarding/inbox-setup'),
      name: 'onboarding_inbox_setup',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingInboxSetup,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
